import React from 'react';

import styles from '../title.module.scss';
import { ReactComponent as Enterprise } from '../../../../icons/entities/enterprise.svg';

export const EnterpriseIcon = <Enterprise className={styles.icon} />;
